exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-3-1!../node_modules/postcss-loader/src/index.js??postcss!antd/dist/antd.css"), "");

// Module
exports.push([module.id, "body,\ndiv,\nul,\nli,\nol,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\ninput,\ntextarea,\nselect,\np,\ndl,\ndt,\ndd,\na,\nimg,\nbutton,\nform,\ntable,\nth,\ntr,\ntd,\ntbody,\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n    margin: 0;\n    padding: 0;\n}\n\nul,\nol,\nli {\n    list-style-type: none;\n}\n\nul,\nol {\n    list-style: none;\n}", ""]);

